var map = {
	"./tooth-11_selected.svg": 51967,
	"./tooth-12_selected.svg": 83630,
	"./tooth-13_selected.svg": 66449,
	"./tooth-14_selected.svg": 67712,
	"./tooth-15_selected.svg": 90011,
	"./tooth-16_selected.svg": 11658,
	"./tooth-17_selected.svg": 23389,
	"./tooth-18_selected.svg": 66652,
	"./tooth-21_selected.svg": 32060,
	"./tooth-22_selected.svg": 19945,
	"./tooth-23_selected.svg": 37158,
	"./tooth-24_selected.svg": 40307,
	"./tooth-25_selected.svg": 96952,
	"./tooth-26_selected.svg": 67541,
	"./tooth-27_selected.svg": 35042,
	"./tooth-28_selected.svg": 13983,
	"./tooth-31_selected.svg": 89693,
	"./tooth-32_selected.svg": 45472,
	"./tooth-33_selected.svg": 42331,
	"./tooth-34_selected.svg": 26702,
	"./tooth-35_selected.svg": 71217,
	"./tooth-36_selected.svg": 42276,
	"./tooth-37_selected.svg": 22399,
	"./tooth-38_selected.svg": 19074,
	"./tooth-41_selected.svg": 15746,
	"./tooth-42_selected.svg": 47475,
	"./tooth-43_selected.svg": 70840,
	"./tooth-44_selected.svg": 36233,
	"./tooth-45_selected.svg": 17510,
	"./tooth-46_selected.svg": 90423,
	"./tooth-47_selected.svg": 444,
	"./tooth-48_selected.svg": 82621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65151;